/**
 * Wraps a dynamic import with retry logic.
 * Handles transient network failures before the error bubbles up to RouteError.
 */
export function lazyImport<T>(
  loader: () => Promise<T>,
  retries = 3,
  delay = 1000
): Promise<T> {
  return new Promise((resolve, reject) => {
    const attempt = (remaining: number) => {
      loader()
        .then(resolve)
        .catch((error: Error) => {
          if (remaining > 0) {
            setTimeout(() => attempt(remaining - 1), delay);
          } else {
            reject(error);
          }
        });
    };
    attempt(retries);
  });
}
